<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0 12L2 10L6 14L14 6L16 8L6 18L0 12ZM12.5 13L13.5 14L21.5 6L23.5 8L13.5 18L10.5 15L12.5 13Z"
  />
</template>
